const securitySettings = {
  "security.change-pin.title": "Cambiar código PIN",
  "security.change-pin.description": "Actualiza tu código PIN para un acceso seguro.",
  "security.update-password.title": "Actualizar contraseña",
  "security.update-password.description": "Cambia la contraseña de tu cuenta.",

  // Pin setup
  "security.pin-setup.title": "Agregar código PIN",
  "security.pin-setup.description": "Crea un código PIN de 4 dígitos para usar para cambiar rápidamente a tu perfil",
  "security.pin-setup.confirm-description": "Vamos a asegurarnos de que el código PIN es correcto (vuelve a ingresar el código PIN)",
  "security.pin-setup.submit-description": "Enviando código PIN",
  "security.pin-setup.mismatch-description": "Los códigos PIN no coinciden, intenta de nuevo",
  "security.pin-setup.add-description": "Agregar código PIN",

  "security.pin-setup.success-title": "Código PIN actualizado",
  "security.pin-setup.success-description": "Tu código PIN ha sido configurado, ahora puedes usarlo para cambiar rápidamente a tu perfil en VR",

  // Password settings
  "security.password-settings.title": "Actualizar contraseña",
  "security.password-settings.description": "Ingresa una nueva contraseña para tu cuenta de Be Your Best",
  "security.password-settings.new-password-label": "Nueva contraseña",
  "security.password-settings.password-length-description": "Debe tener al menos {{ minLength }} caracteres",
  "security.password-settings.confirm-password-label": "Confirmar contraseña",
  "security.password-settings.password-strength-label": "Fuerza de la contraseña:",
  "security.password-settings.passwords-dont-match": "Las contraseñas no coinciden",
  "security.password-settings.success-title": "Contraseña actualizada",
  "security.password-settings.strength.too-short": "Demasiado corto",
  "security.password-settings.strength.weak": "Débil",
  "security.password-settings.strength.medium": "Medio",
  "security.password-settings.strength.good": "Bueno",
  "security.password-settings.strength.strong": "Fuerte",
};

const securityCheckDialog = {
  "security.check-dialog.title": "Asegurando que es tú",
  "security.check-dialog.description": "Por seguridad, por favor ingresa tu contraseña para continuar",
  "security.check-dialog.password-label": "Contraseña",
  "security.check-dialog.error-message": "Contraseña inválida",
  "security.check-dialog.submit-description": "Enviando contraseña",
}

export const security = {
  ...securitySettings,
  ...securityCheckDialog,
};
